import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSetError } from '@src/redux/modals';
import { MiscLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import { TABLEAU_TOKEN_REFRESH_MS } from './tableau-constants';

const fetchTableauToken = async (): Promise<string> => {
  const response = await MiscLambdaFetch('/tableauToken', {
    params: { secret: 'prod/tableauJWTSecrets' }
  });
  return awaitJSON<string>(response);
};

// Surfaces a fetch failure through the shared error modal itself, rather than leaving every
// caller to wire up the same effect — both current callers (CustomDashboard, AmcTableau) did.
export const useTableauToken = (): ReturnType<typeof useQuery<string>> => {
  const setError = useSetError();
  const query = useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['tableauToken'],
    queryFn: fetchTableauToken,
    refetchInterval: TABLEAU_TOKEN_REFRESH_MS
  });

  useEffect(() => {
    if (query.error) {
      setError({
        title: 'Error',
        message: `Error fetching authentication token: ${query.error.message}`,
        reportError: query.error
      });
    }
  }, [query.error, setError]);

  return query;
};
